import { render, staticRenderFns } from "./CategoryAttributeCreationModal.vue?vue&type=template&id=bbb57a28&scoped=true&"
import script from "./CategoryAttributeCreationModal.vue?vue&type=script&lang=js&"
export * from "./CategoryAttributeCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb57a28",
  null
  
)

export default component.exports